import { useListContext } from 'react-admin';
import { FormProvider } from 'react-hook-form';
import { FilterBar, FilterBarActions, FilterBarRow } from 'shared/mui/Filter/FilterBar';
import { FilterApplyButton, FilterResetButton } from 'shared/mui/Filter/FilterButtons';
import { useFilters } from 'shared/mui/Filter/hooks/useFilters';
import { useSyncFilter } from 'shared/mui/Filter/hooks/useSyncFilter';
import {
  AutocompleteInput,
  AutocompleteMultiselectInput,
  TextInput,
} from 'shared/react-admin/Inputs';
import { ReferenceArrayInput } from 'shared/react-admin/ReferenceInputs';

type MethodsFilterValues = {
  name: string;
  alias: string;
  methodType: string[];
  active: string;
};

const DEFAULT_VALUES: MethodsFilterValues = { name: '', alias: '', methodType: [], active: '' };

export const MethodsFilter: React.FC = () => {
  const { filterValues } = useListContext();
  const { form, onReset, onSubmit, appliedFilters } = useFilters<MethodsFilterValues>({
    defaultValues: { ...DEFAULT_VALUES, ...filterValues },
    resetValues: DEFAULT_VALUES,
  });

  useSyncFilter<MethodsFilterValues>({ appliedFilters });

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <FilterBar>
          <FilterBarRow sx={{ gridTemplateColumns: 'repeat(5, 1fr)' }}>
            <TextInput
              helperText={false}
              label="Название"
              name="name"
              source="name"
              sx={{ minWidth: 0 }}
              variant="outlined"
            />
            <TextInput
              helperText={false}
              label="Алиас"
              name="alias"
              source="alias"
              sx={{ minWidth: 0 }}
              variant="outlined"
            />
            <AutocompleteInput
              choices={[
                { id: true, name: 'Активен' },
                { id: false, name: 'Неактивен' },
              ]}
              helperText={false}
              label="Активность"
              name="active"
              optionText="name"
              source="active"
              sx={{ minWidth: 0 }}
              variant="outlined"
            />
            <ReferenceArrayInput perPage={100} reference="method_types" source="methodType">
              <AutocompleteMultiselectInput
                helperText={false}
                label="Типы методов"
                name="methodType"
                optionText="name"
                size="small"
                sx={{ minWidth: 0 }}
              />
            </ReferenceArrayInput>
            <FilterBarActions>
              <FilterResetButton onReset={onReset} />
              <FilterApplyButton type="submit" />
            </FilterBarActions>
          </FilterBarRow>
        </FilterBar>
      </form>
    </FormProvider>
  );
};
